'use client';

import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { initPostHog, trackPageView } from '@/lib/posthog';

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    initPostHog();
  }, []);

  useEffect(() => {
    if (pathname) {
      trackPageView(pathname);
    }
  }, [pathname, searchParams]);

  return <>{children}</>;
}
